<template>
  <div>

    <div v-for="group in groups" :key="group" class="mb-4">
      <h2 v-if="groups.length > 1" class="h5 text-center text-uppercase mb-3">
        {{ group }}
      </h2>

      <div class="table-responsive position-relative">
        <table class="table table-sm table-bordered table-hover mb-0">
          <thead class="thead-light text-uppercase">
          <tr>
            <th>
              <span class="text-monospace d-inline-block text-center" style="width:1.5rem">
                  #
              </span>
              {{ $tc('team.name', 1) }}
            </th>

            <template v-for="tankTableProp in clientConfig.ranking.table">
              <th
                v-if="tankTableProp !== 'lastFiveGamesOutcome'"
                :key="tankTableProp"
                scope="col"
                class="text-center text-nowrap align-middle"
              >
                {{ $t(`sports.${clientConfig.sport}.ranking.table.${tankTableProp}`) }}
              </th>
            </template>

          </tr>
          </thead>

          <tbody class="text-center">
          <tr v-for="(team, index) in data[group]['regular']" :key="team.slug">
            <template v-if="team.name">
              <td
                class="sticky-col align-middle text-nowrap position-sticky left-0 zidx-3"
                :class="highlightCell(team)"
              >
                <div class="d-flex align-items-center gap-1 w-auto">
                <span class="d-inline-block text-center rounded text-white mr-2 bg-grey font-weight-bold" style="width:2rem" :style="{ backgroundColor: team.color + '!important' }">
                  {{ `${index + 1}` }}
                </span>

                  <le-ranking-table-team-cell
                    :schedule-uuid="scheduleUuid"
                    :team="team"
                    :show-full-name="showFullName"
                  />
                </div>
              </td>
              <template v-for="stat in clientConfig.ranking.table">
                <td
                  v-if="stat !=='lastFiveGamesOutcome'"
                  :key="stat"
                  class="align-middle text-nowrap position-relative"
                  :class="highlightCell(team)"
                >
                <span >
                  {{ team[stat] }}
                  <sub
                    v-if="stat === 'score' && team.scoreCorrection && team.scoreCorrection !== 0"
                    :class="{
                      'text-danger': team.scoreCorrection < 0,
                      'text-success': team.scoreCorrection > 0
                    }"
                  >
                    <span v-if="team.scoreCorrection > 0" class="small text-success">+</span>
                    {{ team.scoreCorrection }}
                  </sub>
                </span>
                </td>
              </template>

            </template>
            <template v-else>
              <td class="sticky-col align-middle text-nowrap position-sticky left-0 zidx-3">
                <div class="d-flex align-items-center w-auto">
                  <span><i class="badge badge-info">Empty slot</i></span>
                </div>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>

import LeRankingTableTeamCell from '@/components/le/LeRankingTableTeamCell.vue'

export default {
  name: 'LeagueRankingTable',
  components: { LeRankingTableTeamCell },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    scheduleUuid: { type: String, required: true }
  },
  data () {
    return { showFullName: false }
  },
  computed: {
    groups () {
      return Object.keys(this.data)
    },
    clientConfig () {
      return this.$store.state.config
    }
  },
  methods: {
    highlightCell (team) {
      const isHighlighted = this.homeTeam === team.slug || this.awayTeam === team.slug
      // Bootstrap 4 utility classes
      return isHighlighted ? 'table-primary font-weight-bold' : ''
    }
  }
}
</script>
